import { Component, ElementRef, Input, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IControls } from 'bi-interfaces';

@Component({
  selector: 'bi-floating-color-picker',
  templateUrl: './bi-floating-color-picker.component.html',
  styleUrls: ['./bi-floating-color-picker.component.css']
})
export class BiFloatingColorPickerComponent {
  @Input() FormControl!: FormControl;
  @Input() Control!: IControls;
  public hexaDecimalColor!: string|null;
  @ViewChild('InputColor', { static: true }) InputColor: ElementRef | any;

  ngAfterViewInit() {

  }

  ngOnInit(): void {
    if (this.FormControl.value?.includes('#')) {
      this.FormControl.patchValue(this.FormControl.value)
    } else {

      this.hexaDecimalColor = this.rgbStringToHex(`rgba(${this.FormControl.value})`)
      this.FormControl.patchValue(this.hexaDecimalColor)
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['FormControl']) {
      if (changes['FormControl'].currentValue.value?.includes('#')) {
        this.FormControl.patchValue(changes['FormControl'].currentValue.value)
      } else {

        this.hexaDecimalColor = this.rgbStringToHex(`rgba(${changes['FormControl'].currentValue.value})`)
        this.FormControl.patchValue(this.hexaDecimalColor)
      }
    }
  }
  setColor(formControl:any) {
    setTimeout(() => {
      this.InputColor.nativeElement.click()
    }, 20)
    formControl.patchValue(!formControl.value ? '#000000' : formControl.value)

  }
  RemoveColor(event:any, formControl:any) {
    event.stopPropagation()
    formControl.patchValue(null)
    formControl.markAsDirty()

  }


  rgbStringToHex(rgbString:string) {
    // Extract RGB components from the string
    const rgbRegex = /rgba?\((\d+),\s*(\d+),\s*(\d+)/;
    const match = rgbString.match(rgbRegex);

    if (!match) {
      // Invalid input format
      return null;
    }

    const [, r, g, b] = match;

    // Convert each RGB component to hexadecimal
    const componentToHex = (c:any) => {
      const hex = parseInt(c).toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    };

    // Clamp and convert RGB values to hexadecimal
    const hexR = componentToHex(r);
    const hexG = componentToHex(g);
    const hexB = componentToHex(b);

    // Construct and return the hexadecimal color string
    return '#' + hexR + hexG + hexB;
  }

}
